var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArtworkNotFound = function SvgArtworkNotFound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 735,
    height: 559,
    viewBox: "0 0 735 559",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 52.243h88.908V0H0z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cy: "0%",
    r: "176.913%",
    fx: "50%",
    fy: "0%",
    gradientTransform: "scale(-.5876 -1) rotate(-71.255 -.175 .943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#444",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 52.243h88.908V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 205.792h129.998V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252529",
    d: "M2 536h733v1H2zM158 523h349v1H158z",
    opacity: 0.805
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252529",
    d: "M158 558h350v1H158z",
    opacity: 0.211
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3E3F42",
    d: "M458.144 428.43L163.993 508.18M206.3 428.137l295.229 80.045"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 412.876h379.104v-6.111H143zM143 406.765L148.769 396h367.566l5.769 10.765z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M158.866 428.137h109v-15.261h-109zM397.238 428.137h109.097v-15.261H397.238z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.013 412.876v122.087M158.77 534.963V412.876M158.77 534.963h-8.757"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M163.244 523.068v-94.93M163.244 523.068h-4.475"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.09 412.876v122.087M506.335 534.963V412.876M506.335 534.963h8.756"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M501.86 523.068v-94.93M501.86 523.068h4.474M267.866 428.137l8.178-15.26M397.238 428.137l-8.178-15.26"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M529.272 491.433l23.552 44.295 75.047-39.903-23.552-44.295z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M563.232 473.377l23.552 44.294 33.96-18.056-23.552-44.295z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M529.272 491.433l23.552 44.295 33.96-18.057-23.552-44.294zM601.468 476.075l4.46 8.388.938-.499-4.46-8.388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M567.507 494.132l4.46 8.388.938-.499-4.46-8.388zM622.649 494.6a.531.531 0 1 1-.498-.938.531.531 0 0 1 .498.939z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M597.192 455.32l23.552 44.294 7.127-3.789-23.552-44.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M577.168 443.07a.649.649 0 0 1-.88-.269.657.657 0 0 1 .265-.887.66.66 0 0 1 .892.272.65.65 0 0 1-.277.884zm-6.626-2.513l2.977 5.597-53.622 28.511 8.136 15.302 9.616-5.113-3.756-7.063 42.893-22.807 3.756 7.063 9.368-4.98-11.112-20.9-8.256 4.39z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M577.168 443.07a.649.649 0 0 1-.88-.269.657.657 0 0 1 .265-.887.66.66 0 0 1 .892.272.65.65 0 0 1-.277.884zm-6.626-2.513l2.977 5.597-53.622 28.511 8.136 15.302 9.616-5.113-3.756-7.063 42.893-22.807 3.756 7.063 9.368-4.98-11.112-20.9-8.256 4.39z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M537.649 484.855l42.893-22.807-3.756-7.064-42.893 22.807zM577.445 442.186a.65.65 0 0 1-.277.884.649.649 0 0 1-.88-.269.657.657 0 0 1 .265-.887.66.66 0 0 1 .892.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M530.695 461.744l34.329-18.253-13.615-25.606-34.329 18.254z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M530.695 461.744l34.329-18.253-13.615-25.606-34.329 18.254z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M537.649 484.855l42.893-22.807-3.756-7.064-42.893 22.807z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M577.445 442.186a.65.65 0 0 1-.277.884.649.649 0 0 1-.88-.269.657.657 0 0 1 .265-.887.66.66 0 0 1 .892.272zM537.649 484.855l42.893-22.807-3.756-7.064-42.893 22.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M519.897 474.666l53.622-28.511-2.977-5.598-53.621 28.51z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M519.897 474.666l53.622-28.511-2.977-5.598-53.621 28.51zM520.985 470.496l9.491-5.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3F42",
    fillRule: "nonzero",
    d: "M533.408 443.346c.571 1.075.707 2.144.409 3.209-.299 1.064-.985 1.882-2.06 2.453-1.054.561-2.097.663-3.13.307-1.034-.357-1.837-1.072-2.408-2.146l-.84-1.582c-.57-1.07-.714-2.134-.432-3.192.281-1.058.947-1.867 1.997-2.425 1.074-.571 2.138-.682 3.19-.334 1.053.35 1.864 1.059 2.433 2.129l.84 1.581zm-2.308-.816c-.39-.733-.906-1.23-1.548-1.492-.643-.262-1.298-.216-1.966.14-.644.342-1.028.848-1.152 1.517-.124.67.01 1.371.399 2.103l.847 1.594c.394.74.903 1.247 1.529 1.521.625.274 1.262.239 1.91-.106.672-.357 1.077-.874 1.215-1.552.138-.677.009-1.388-.387-2.132l-.847-1.593zm3.584.494c-.515-.97-.674-1.908-.474-2.814.208-.91.772-1.61 1.694-2.1.937-.499 1.837-.578 2.7-.236.865.335 1.556.99 2.074 1.963l.067.127c.522.982.68 1.925.475 2.829-.204.898-.77 1.594-1.7 2.088-.934.497-1.833.577-2.698.242-.86-.337-1.55-.995-2.07-1.972l-.068-.127zm1.534-.653c.338.636.739 1.088 1.202 1.358.458.268.95.262 1.477-.019.511-.271.787-.674.83-1.207.043-.54-.105-1.127-.443-1.763l-.067-.126c-.332-.624-.733-1.069-1.205-1.334-.47-.272-.964-.27-1.483.007-.51.271-.785.678-.822 1.219-.034.539.114 1.118.444 1.738l.067.127zm11.609-5.98c.505.95.689 1.836.553 2.657-.137.82-.603 1.443-1.4 1.867-.37.196-.734.304-1.09.324a2.293 2.293 0 0 1-1.048-.194l1.685 3.168-1.466.78-4.808-9.041 1.237-.658.582.744c.046-.417.175-.785.385-1.103a2.4 2.4 0 0 1 .9-.789c.805-.428 1.602-.442 2.39-.043.787.4 1.458 1.12 2.012 2.162l.068.127zm-1.528.65c-.355-.667-.772-1.147-1.249-1.437-.477-.291-.965-.304-1.464-.039-.306.163-.53.366-.674.61a1.636 1.636 0 0 0-.223.82l1.57 2.951c.25.161.515.246.793.255.279.01.575-.069.889-.236.499-.265.774-.648.826-1.147.051-.5-.082-1.05-.4-1.65l-.068-.126zm7.154-2.007a.772.772 0 0 0-.588-.407c-.272-.047-.702.014-1.289.182-.868.25-1.583.33-2.145.238-.562-.09-.982-.397-1.26-.92-.291-.548-.308-1.138-.05-1.77.257-.632.763-1.15 1.52-1.552.797-.423 1.534-.564 2.211-.42.677.142 1.16.51 1.448 1.1l.007.042-1.406.748a1.042 1.042 0 0 0-.677-.53c-.308-.085-.64-.032-.999.159-.354.188-.581.41-.682.668-.1.258-.09.5.032.73a.74.74 0 0 0 .553.407c.247.042.666-.027 1.256-.207.911-.268 1.646-.353 2.206-.256.56.097.982.411 1.264.942.312.588.324 1.194.033 1.818-.29.624-.831 1.146-1.624 1.568-.849.451-1.634.59-2.356.417-.722-.174-1.221-.549-1.496-1.125l-.008-.043 1.364-.725c.218.37.501.573.85.609.35.036.71-.045 1.08-.241.378-.201.632-.429.76-.683a.772.772 0 0 0-.004-.75z",
    opacity: 0.752
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(107 153.255 500.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8F",
    d: "M14.604 39.923h30.41a5 5 0 1 1 0 10h-30.41a5 5 0 1 1 0-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EA0A5",
    fillRule: "nonzero",
    d: "M23.567 25.5l7.923-7.874h4.494v8.724H24.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF0F1",
    d: "M18.5 23.5l10.397-10.74h11.906v22.168H18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6CAD2",
    d: "M14.403 34.584h30.733v5.34H14.403z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF0F1",
    d: "M24.228 17L7.65.734h-5.1v11.18h1.94l1.923-4.851 14.018 13.515z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 45.5,
    r: 2.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 45.5,
    r: 2.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 45.5,
    r: 2.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.74 17h-4.688a.85.85 0 0 0-.601.25l-7.212 7.212a.851.851 0 0 0-.25.6v1.288c0 .47.382.85.85.85h11.9c.47 0 .85-.38.85-.85v-8.5a.85.85 0 0 0-.85-.85zm-.85 8.5h-10.2v-.085l6.715-6.715h3.485v6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94 39.168V34.85a.85.85 0 0 0-.85-.85h-3.4V12.75a.85.85 0 0 0-.85-.85h-11.9a.852.852 0 0 0-.601.249l-4.074 4.074L8.29.249A.85.85 0 0 0 7.69 0h-5.1a.85.85 0 0 0-.85.85V11.9c0 .47.38.85.85.85v5.95c0 .47.38.85.85.85a1.7 1.7 0 1 1-1.7 1.7.85.85 0 1 0-1.7 0 3.4 3.4 0 1 0 4.25-3.28v-5.22a.849.849 0 0 0 .79-.538l1.574-3.988 12.805 12.805-1.32 1.32a.85.85 0 0 0-.25.6V34h-3.4a.85.85 0 0 0-.85.85v4.32A5.95 5.95 0 0 0 14.49 51h30.6a5.95 5.95 0 0 0 .85-11.832zm-39-33.062a.85.85 0 0 0-1.392.288L3.71 11.05h-.27V1.7h3.897l15.725 15.725-2.402 2.402L6.939 6.106zm12.65 17.196l9.702-9.702H39.99V34h-20.4V23.302zM15.34 35.7h28.9v3.4h-28.9v-3.4zm29.75 13.6h-30.6a4.25 4.25 0 1 1 0-8.5h30.6a4.25 4.25 0 0 1 0 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.79 41.65a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zm0 5.1a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4zM39.99 41.65a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zm0 5.1a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4zM19.4 42a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zm0 5.1a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M465.263 535.053h28.14v-58.08h-28.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M465.263 535.053h28.14v-58.08h-28.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M465.263 481.687h28.14v-4.713h-28.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M465.263 486.4h28.14v-4.713h-28.14zM465.263 535.053h28.14v-29.04h-28.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M481.791 520.534a2.458 2.458 0 1 1-4.916 0 2.458 2.458 0 0 1 4.916 0zM465.263 496.207h28.14V486.4h-28.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M403.06 535.987h59.25V497.09h-59.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M403.06 535.987h59.25V497.09h-59.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M403.06 506.383h59.25v-9.294h-59.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M412.56 508.758h4.75v-4.75h-4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M412.56 508.758h4.75v-4.75h-4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M448.06 508.758h4.75v-4.75h-4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M448.06 508.758h4.75v-4.75h-4.75zM427.31 497.16h10.75v-4.587h-10.75zM407.643 497.16v38.827M457.726 497.16v38.827"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M233.222 401.158l18.83-.329-.194-11.062-18.83.328z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M242.457 389.93l8.928-.156 1.194 11.045-19.857.347.807-11.08 8.928-.156M229.668 401.22l25.965-.454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M195.333 396.604l95.046-11.67-1.573-12.814-95.046 11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M193.76 383.79l95.046-11.67-7.075-57.618-95.046 11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M193.76 383.79l95.046-11.67-7.075-57.618-95.046 11.67z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7 2786.06 -1392.745)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#595959",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M0 52.243h88.908V0H0z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#95959A",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    fillOpacity: 0.4,
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M242.313 386.35a2.188 2.188 0 1 1 1.904-2.438 2.187 2.187 0 0 1-1.904 2.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M195.333 396.604l95.046-11.67-1.573-12.814-95.046 11.67z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268 353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M28.25 200.444a3.281 3.281 0 1 1-6.563 0 3.281 3.281 0 0 1 6.562 0zM68.28 201.51a3.281 3.281 0 1 1-6.562 0 3.281 3.281 0 0 1 6.562 0M101.75 201.51a3.281 3.281 0 1 1-6.563 0 3.281 3.281 0 0 1 6.562 0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M56.001 133.68h18v-9.75h-18z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M60.501 157.34h9v-23.66h-9z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M58.251 182.51h13.5v-25.17h-13.5zM101.751 188.43v5.62l-30-2.81-3.94 2.81h-5.62l-3.94-2.81-30 2.81v-5.62l30-5.92h13.5z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M106.901 116.85v2.21c0 2.69-2.18 4.87-4.86 4.87h-74.08c-2.69 0-4.86-2.18-4.86-4.87 0-5.11.18-10.21.54-15.31l6.81-96.33a6.914 6.914 0 0 1 6.9-6.42h55.46c3.63 0 6.64 2.8 6.89 6.42l6.66 94.12c.36 5.1.54 10.2.54 15.31M109.901 88.352h19.097v-6.167h-19.097zM1 88.352h19.097v-6.167H1z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.82 104.018h3.457V88.351H8.82zM117.721 104.018h3.457V88.351h-3.457z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M74 128.177h35.935a9.515 9.515 0 0 0 9.515-9.515v-14.644M10.548 104.018v14.644a9.515 9.515 0 0 0 9.515 9.515H56",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M56.001 133.68h18v-9.75h-18zM60.501 157.34h9v-23.66h-9z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58.251 182.51h13.5v-25.17h-13.5zM101.751 188.43v5.62l-30-2.81-3.94 2.81h-5.62l-3.94-2.81-30 2.81v-5.62l30-5.92h13.5zM65 194.052v4.178M28.25 194.052v6.392M101.75 194.052v7.459M28.25 200.444a3.281 3.281 0 1 1-6.563 0 3.281 3.281 0 0 1 6.562 0zM68.28 201.51a3.281 3.281 0 1 1-6.562 0 3.281 3.281 0 0 1 6.562 0zM101.75 201.51a3.281 3.281 0 1 1-6.563 0 3.281 3.281 0 0 1 6.562 0zM106.901 116.85v2.21c0 2.69-2.18 4.87-4.86 4.87h-74.08c-2.69 0-4.86-2.18-4.86-4.87 0-5.11.18-10.21.54-15.31l6.81-96.33a6.914 6.914 0 0 1 6.9-6.42h55.46c3.63 0 6.64 2.8 6.89 6.42l6.66 94.12c.36 5.1.54 10.2.54 15.31zM109.901 88.352h19.097v-6.167h-19.097zM1 88.352h19.097v-6.167H1zM74 131.344h18.666M92.666 131.344l8.208 2.333",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    stroke: "#444",
    d: "M147.963 518.903l-18.266-1.261v17.724l18.266-1.261z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    d: "M129.697 517.642a6.85 6.85 0 0 1 13.7 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3E3F42",
    d: "M126.543 534.543a9.938 9.938 0 0 1-7.596-3.49M103.543 534.543a9.938 9.938 0 0 1-7.596-3.49M106.428 534.917a9.938 9.938 0 0 1 8.1-2.068"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.809 164.797V188H.977v-63.984h25.488c7.353 0 13.14 1.875 17.358 5.625 4.219 3.75 6.328 8.686 6.328 14.81 0 6.122-2.109 11.044-6.328 14.765-4.219 3.72-10.005 5.58-17.358 5.58H13.809zm0-9.888h12.656c3.574 0 6.284-.974 8.13-2.922 1.845-1.948 2.768-4.431 2.768-7.449 0-3.076-.915-5.618-2.746-7.624-1.831-2.007-4.549-3.01-8.152-3.01H13.809v21.005zM85.923 188a26.99 26.99 0 0 1-1.209-3.428 23.844 23.844 0 0 1-.725-3.691 17.684 17.684 0 0 1-5.207 5.757c-2.154 1.523-4.724 2.285-7.713 2.285-4.98 0-8.818-1.282-11.513-3.845-2.696-2.564-4.043-6.057-4.043-10.481 0-4.659 1.794-8.27 5.383-10.833 3.589-2.563 8.826-3.845 15.71-3.845h7.164v-3.78c0-2.285-.601-4.057-1.802-5.317-1.201-1.26-2.974-1.89-5.318-1.89-2.08 0-3.684.506-4.812 1.517-1.128 1.01-1.692 2.41-1.692 4.197l-12.392-.044-.044-.264c-.205-4.014 1.538-7.478 5.23-10.393 3.69-2.915 8.54-4.373 14.545-4.373 5.684 0 10.298 1.443 13.843 4.329 3.545 2.886 5.318 6.994 5.318 12.327v19.643c0 2.227.168 4.321.505 6.284A31.534 31.534 0 0 0 98.755 188H85.923zm-11.734-8.57c2.256 0 4.263-.556 6.021-1.67 1.758-1.113 2.944-2.402 3.56-3.866v-6.724h-7.164c-2.724 0-4.79.681-6.196 2.043-1.406 1.363-2.11 3.01-2.11 4.944 0 1.582.528 2.857 1.583 3.823 1.055.967 2.49 1.45 4.306 1.45zm30.19-14.809c0-7.5 1.634-13.55 4.9-18.15 3.267-4.599 7.845-6.899 13.734-6.899 2.666 0 5.01.6 7.03 1.802 2.022 1.201 3.75 2.915 5.186 5.142l1.011-6.065h11.074v47.33c0 6.18-2.028 10.964-6.086 14.347-4.058 3.384-9.705 5.076-16.94 5.076-2.403 0-4.952-.33-7.647-.989-2.696-.659-5.186-1.56-7.471-2.702l2.373-9.58a29.94 29.94 0 0 0 5.999 2.131c2.036.483 4.255.725 6.657.725 3.516 0 6.101-.732 7.757-2.197 1.655-1.465 2.482-3.75 2.482-6.856v-4.306c-1.406 1.787-3.061 3.15-4.965 4.087-1.905.937-4.087 1.406-6.548 1.406-5.83 0-10.379-2.146-13.645-6.438-3.267-4.292-4.9-9.94-4.9-16.941v-.923zm12.833.923c0 4.16.703 7.434 2.11 9.822 1.406 2.387 3.69 3.581 6.855 3.581 1.963 0 3.625-.359 4.988-1.076 1.362-.718 2.453-1.766 3.273-3.142v-20.655c-.82-1.435-1.911-2.549-3.273-3.34-1.363-.79-2.996-1.186-4.9-1.186-3.135 0-5.428 1.391-6.878 4.175-1.45 2.783-2.175 6.416-2.175 10.898v.923zm60.996 23.379c-6.855 0-12.334-2.197-16.436-6.592-4.101-4.394-6.152-9.975-6.152-16.743v-1.758c0-7.06 1.941-12.876 5.823-17.446 3.882-4.57 9.09-6.841 15.622-6.812 6.416 0 11.397 1.934 14.942 5.801s5.317 9.097 5.317 15.689v6.987h-28.388l-.088.263c.234 3.135 1.281 5.713 3.142 7.735 1.86 2.021 4.387 3.032 7.58 3.032 2.842 0 5.2-.286 7.076-.857 1.875-.571 3.925-1.472 6.152-2.702l3.472 7.91c-1.934 1.582-4.468 2.893-7.603 3.933s-6.621 1.56-10.459 1.56zm-1.143-39.463c-2.373 0-4.248.908-5.625 2.725-1.377 1.816-2.226 4.204-2.548 7.163l.131.22h15.733v-1.143c0-2.725-.637-4.9-1.912-6.526-1.274-1.626-3.2-2.439-5.779-2.439zM120.227 100.516l11.82 2.513-3.441 16.19-11.82-2.512-4.813 22.64-20.848-4.432 4.812-22.639-42.555-9.045 1.734-12.736 57.966-59.936 21.063 4.477-13.918 65.48zm-44.848-9.532l24 5.101 7.98-37.54-.4-.235-2.272 2.587-29.308 30.087zM317.655 131.451l.572 6.812c1.582-2.432 3.53-4.322 5.844-5.67 2.315-1.347 4.908-2.02 7.779-2.02 4.804 0 8.554 1.508 11.25 4.526 2.695 3.017 4.043 7.749 4.043 14.194V179h-12.876v-29.663c0-3.193-.645-5.457-1.934-6.79-1.29-1.333-3.237-2-5.845-2-1.699 0-3.222.345-4.57 1.034a9.394 9.394 0 0 0-3.384 2.922V179h-12.832v-47.549h11.953zm37.09 23.335c0-7.09 1.978-12.898 5.933-17.424 3.955-4.527 9.433-6.79 16.435-6.79 7.032 0 12.54 2.256 16.524 6.768 3.984 4.512 5.976 10.327 5.976 17.446v.923c0 7.148-1.985 12.971-5.954 17.468-3.97 4.497-9.456 6.746-16.458 6.746-7.031 0-12.532-2.249-16.501-6.746-3.97-4.497-5.955-10.32-5.955-17.468v-.923zm12.788.923c0 4.336.762 7.815 2.285 10.437 1.524 2.622 3.985 3.933 7.383 3.933 3.31 0 5.735-1.318 7.273-3.955 1.538-2.637 2.307-6.108 2.307-10.415v-.923c0-4.219-.776-7.661-2.329-10.327-1.553-2.666-3.999-3.999-7.339-3.999-3.31 0-5.735 1.34-7.273 4.021-1.538 2.68-2.307 6.116-2.307 10.305v.923zm55.24-35.903v11.645h7.998v9.009h-7.999v24.214c0 1.846.381 3.164 1.143 3.955.762.79 1.787 1.186 3.076 1.186.674 0 1.253-.036 1.736-.11a15.223 15.223 0 0 0 1.692-.373l1.099 9.272a25.75 25.75 0 0 1-3.78.99c-1.23.219-2.563.329-3.999.329-4.424 0-7.83-1.216-10.217-3.648-2.388-2.431-3.582-6.284-3.582-11.557V140.46h-6.943v-9.009h6.943v-11.645h12.832zM404.102 67.472c0 14.111-3.235 24.817-9.705 32.116-6.47 7.3-15.222 10.95-26.257 10.95-11.133 0-19.947-3.65-26.44-10.95-6.495-7.3-9.742-18.005-9.742-32.116V43.96c0-14.063 3.235-24.768 9.705-32.117 6.47-7.348 15.246-11.023 26.33-11.023 11.035 0 19.812 3.675 26.33 11.023 6.52 7.349 9.779 18.054 9.779 32.117v23.51zm-21.314-25.708c0-8.448-1.27-14.637-3.809-18.567-2.539-3.93-6.2-5.896-10.986-5.896-4.834 0-8.496 1.953-10.986 5.86-2.49 3.905-3.736 10.107-3.736 18.603v27.758c0 8.594 1.258 14.844 3.772 18.75 2.515 3.907 6.214 5.86 11.097 5.86 4.785 0 8.422-1.953 10.913-5.86 2.49-3.906 3.735-10.156 3.735-18.75V41.764z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512.262 201v-38.54h-7.075v-9.009h7.075v-5.273c0-5.332 1.538-9.441 4.614-12.327 3.076-2.886 7.397-4.329 12.964-4.329 1.084 0 2.19.081 3.318.242a52.67 52.67 0 0 1 3.713.681l-1.099 9.536a63.45 63.45 0 0 0-2.043-.307 17.684 17.684 0 0 0-2.307-.132c-2.08 0-3.655.571-4.724 1.714-1.07 1.142-1.604 2.783-1.604 4.922v5.273h9.448v9.009h-9.448V201h-12.832zm26.85-24.214c0-7.09 1.978-12.898 5.933-17.424 3.955-4.527 9.433-6.79 16.435-6.79 7.032 0 12.54 2.256 16.524 6.768 3.984 4.512 5.976 10.327 5.976 17.446v.923c0 7.148-1.984 12.971-5.954 17.468-3.97 4.497-9.456 6.746-16.458 6.746-7.03 0-12.531-2.249-16.501-6.746-3.97-4.497-5.955-10.32-5.955-17.468v-.923zm12.788.923c0 4.336.762 7.815 2.286 10.437 1.523 2.622 3.984 3.933 7.382 3.933 3.31 0 5.735-1.318 7.273-3.955 1.538-2.637 2.307-6.108 2.307-10.415v-.923c0-4.219-.776-7.661-2.329-10.327-1.552-2.666-3.999-3.999-7.339-3.999-3.31 0-5.734 1.34-7.272 4.021-1.539 2.68-2.308 6.116-2.308 10.305v.923zm69.038 16.436c-1.464 2.49-3.325 4.409-5.58 5.756-2.256 1.348-4.85 2.022-7.779 2.022-5.01 0-8.928-1.604-11.755-4.812s-4.241-8.196-4.241-14.964v-28.696h12.788v28.784c0 3.457.586 5.94 1.758 7.45 1.172 1.508 2.9 2.262 5.185 2.262 2.051 0 3.809-.33 5.274-.989a8.89 8.89 0 0 0 3.603-2.922v-34.585h12.832V201h-10.942l-1.143-6.855zm33.487-40.694l.571 6.812c1.582-2.432 3.53-4.322 5.845-5.67 2.314-1.347 4.907-2.02 7.778-2.02 4.805 0 8.555 1.508 11.25 4.526 2.695 3.017 4.043 7.749 4.043 14.194V201h-12.876v-29.663c0-3.193-.644-5.457-1.933-6.79-1.29-1.333-3.238-2-5.845-2-1.7 0-3.223.345-4.57 1.034a9.394 9.394 0 0 0-3.384 2.922V201h-12.832v-47.549h11.953zm37.09 24.17c0-7.5 1.618-13.55 4.856-18.15 3.237-4.599 7.8-6.899 13.689-6.899 2.373 0 4.511.513 6.416 1.538 1.904 1.026 3.574 2.49 5.01 4.395v-26.06h12.875V201h-11.03l-1.055-5.8c-1.494 2.196-3.259 3.866-5.295 5.009-2.036 1.143-4.373 1.714-7.01 1.714-5.83 0-10.363-2.139-13.6-6.416-3.238-4.278-4.856-9.932-4.856-16.963v-.923zm12.788.923c0 4.16.703 7.434 2.11 9.822 1.405 2.387 3.69 3.581 6.855 3.581 1.845 0 3.457-.373 4.834-1.12 1.377-.747 2.504-1.839 3.383-3.274v-20.26c-.879-1.493-2-2.658-3.361-3.493-1.363-.835-2.952-1.252-4.769-1.252-3.134 0-5.427 1.391-6.877 4.175-1.45 2.783-2.175 6.416-2.175 10.898v.923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.962 138.621l1.473 11.995-16.43 2.018-1.472-11.995-22.972 2.82-2.598-21.154 22.972-2.82-5.302-43.182 12.606-2.508 75.543 35.295 2.625 21.373-66.445 8.158zm-5.587-45.507l2.99 24.353 38.093-4.677.091-.454-3.185-1.306-37.99-17.916z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArtworkNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "artworkNotFound.51e55209daa091db0dd255c6e467a725.svg";